import getItemsCountHorizontalFlatListSelectUtil from 'utils/flat-list/get-items-count-horizontal/utils/index.js'

const getItemsCountHorizontalFlatListSelect = state => {
  return getItemsCountHorizontalFlatListSelectUtil(state.viewport)
}

export default getItemsCountHorizontalFlatListSelect
